<template>
  <div>
    <div>
      <v-container>
        <v-layout wrap>
          <v-flex md2 sm12>
            <choose-date label="From" v-model="start"></choose-date>
          </v-flex>
          <v-flex md2 sm12>
            <choose-date label="To" v-model="end"></choose-date>
          </v-flex>
        </v-layout>
      </v-container>
     
      <DataTable :url="'captains-complaints-stats'" :enable-edit="false" :enable-add="false" :enable-delete="false"
        :disableSearch="true" :sortable="false" :formatter="formatters" :initial-url-search-params="dateParams"
        :actions-extra-main="actionsExtraMain" perPage="25" :fields-hidden-main="['car', 'cars']" :titles="titles" />

    </div>

  </div>
</template>

<style lang="scss"></style>

<script>
import DataTable from "@/components/monaco/DataTable";
import { companyNow } from "@/util/companyTime";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "ComplaintsStats",
  title: "Complaints Statistics",
  components: { DataTable, ChooseDate },
  data() {
    return {
      stats: [],
      newPosition: null,
      selectedCaptain: null,
      loading: false,
      pagination: {
        rowsPerPage: 25
      },
      start: "",
      end: "",
      formatters: {

      }
    };
  },

  computed: {
    titles() {
      return {
        id: "#",
        username: "Taxi Number",
        first_name: "First Name",
        last_name: "Last Name",
        complaints_count: "Complaints"
      };
    },
    dateParams() {
      const params = new URLSearchParams();
      params.append("start", this.start);
      params.append("end", this.end);
      return params;
    },
    actionsExtraMain() {
      return {
        captain: {
          title: "Captain Profile",
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              path:"/captains/"+ item.id,
              query: { tab: 7 }
            }),
        },
      };
    },
  },
  methods: {

  },
  mounted() {
    this.start = companyNow().startOf('month').format("YYYY-MM-DD");
    this.end = companyNow().format("YYYY-MM-DD");
  
  },
};
</script>
